// ----------------------------------------------------------------------------
// Template: Product
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'snippets/breadcrumbs/breadcrumbs';
import 'snippets/cart-confirmation/cart-confirmation';
import 'snippets/_containers/swatches/swatches';
import 'snippets/specs-table/specs-table';
import 'snippets/product-form/product-form';
import 'snippets/product-zoom/product-zoom';
import 'snippets/product-sfp-zoom/product-sfp-zoom';
import 'sections/featured-collection/featured-collection';
import 'sections/pdp-content-panel/pdp-content-panel';
import 'sections/compare-block/compare-block';
import 'sections/faqs/faqs';
import 'sections/main-product/main-product';
import 'sections/main-bundle-product/main-bundle-product';
import 'sections/product-recommendations/product-recommendations';
import 'sections/bv-reviews/bv-reviews';

// -------------------------------------
// Hooks
// -------------------------------------
// Section bootstrapping: `load('*')` runs once from `assets/scripts/app.js`